module.exports = __webpack_public_path__ + "img/3_pfw_fr.6ce22dee.jpg";